import type { UniclientAction, UniclientImage } from '@lemonade-hq/uniclient-chat';
import { Button, Flex, Layout, spacing } from '@lemonade-hq/uniclient-theme';
import { useCallback } from 'react';
import { WizardImage } from '../../../adapters/components/Image/WizardImage';
import * as wizardStyles from '../../Wizard.css';

interface LandingPageProps {
  readonly logo: UniclientImage;
  readonly performAction: (action: UniclientAction) => Promise<unknown>;
  readonly action: UniclientAction;
}

export const LandingPage: React.FC<LandingPageProps> = ({ logo, performAction, action }) => {
  const handleAction = useCallback(() => {
    void performAction(action);
  }, [performAction, action]);

  return (
    <Flex
      alignItems={{ lg: 'center' }}
      flex={1}
      flexDirection="column"
      justifyContent={{ sm: 'space-between', lg: 'center' }}
      pb={wizardStyles.bottomSafeAreaHeightVar}
      pt={wizardStyles.topSafeAreaHeightVar}
      px={spacing.s16}
    >
      <Flex flex={{ sm: 1, lg: 0 }} flexDirection="column" gap={spacing.s24}>
        <Flex alignItems="center" flex={{ sm: 1, lg: 0 }} justifyContent="center">
          <WizardImage {...logo} />
        </Flex>
        <Layout
          as={Button}
          data-animated
          onClick={handleAction}
          variant={action.primary ? 'primary' : 'secondary'}
          width="100%"
        >
          {action.content}
        </Layout>
      </Flex>
    </Flex>
  );
};
